import React, { useState, useEffect } from 'react'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

// @material-ui/core components
import { Typography, Modal, Button, Box } from '@material-ui/core'
import _ from 'lodash'

const evt = new Event('customertable_is_dirty');


const useStyles = makeStyles((theme) => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: theme.palette.background.default,
    border: '2px solid #000',
    boxShadow: 24,
    padding: 4,
  },
}))


const DetailsAddComponent = ({add_new_url, editable_fields}) => {
  const [status, setStatus] = React.useState({ kind: "idle", message: "" }); 
  const [materials, setMaterials] = useState({})

  const auth = useSelector(state => state.auth)

  // submit data and update object
  const handleSubmit = (event) => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    event.preventDefault();
    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    setStatus({ kind: "loading", message: "" });

    axios.post(add_new_url, value, config)
      .then(() => {
        setStatus({ kind: "success", message: "Inserted" });
        window.dispatchEvent(evt);
      })
      .catch((err) => {
        setStatus({ kind: "error", message: err.response.data.msg });
      });
  }

  // get enum-values for materials
  useEffect(() => {
    const fetchMaterialtypes = () => {
      const config = {headers:{'Content-Type':'application/json'}}

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      axios.get(`${ServerConfig.SERVER_URL}/admin/materials`, config)
          .then((res) => {
            setMaterials(res.data)
          }).catch((error) => {
            console.error('Error fetching material types:', error);
          });
    };

      fetchMaterialtypes();
    }, [])

  const unsavedChanges = () => {
    setStatus({ kind: "info", message: "Unsaved changes" });
  };

  return (
    <>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Add
      </Typography>

      <hr />

      <form onSubmit={handleSubmit}>
        {
          editable_fields.map(function (fieldname) {
            switch (fieldname[2]) {
              case "date":
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                  <input type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue="" onChange={unsavedChanges} />
                </div>
              case "material":
                  return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': "150px" }}>{fieldname[1]}</label>
                      <select className="form-control" style={{ 'display': 'block', 'width': "256px" }} name={fieldname[0]} id={fieldname[0]}  onChange={unsavedChanges}>
                        {_.map(materials, opt => { return (
                          <option value={opt}>{opt}</option>
                          )
                          })}
                      </select>
                    </div>
              case "select":
                  return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                      <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': "150px" }}>{fieldname[1]}</label>
                      <select className="form-control" style={{ 'display': 'block', 'width': "256px" }} name={fieldname[0]} id={fieldname[0]} onChange={unsavedChanges}>
                        {_.map(fieldname[3], opt => { return (
                          <option value={opt}>{opt}</option>
                          )
                          })}
                      </select>
                    </div>
              default:
                return <div className="form-group" style={{ 'float': 'left', 'margin': '10px' }}>
                  <label htmlFor={fieldname[0]} style={{ 'display': 'block', 'width': 150 + "px" }}>{fieldname[1]}</label>
                  <input type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue="" onChange={unsavedChanges} />
                </div>
            }

          })
        }
        <br style={{ 'clear': 'both' }} />
        <Button type='submit' style={{ 'margin': '10px', 'display': 'block', 'float': 'left' }}>Save</Button>
        <Typography
          id="details_status"
          variant="h6"
          component="h2"
          style={{ lineHeight: '36px', padding: '10px' }}
        >
          {status.kind === "loading" && "Saving..."}
          {status.kind === "success" && status.message}
          {status.kind === "error" && <span style={{ color: 'red' }}>ERROR: {status.message}</span>}
          {status.kind === "info" && status.message}
        </Typography>
      </form>

    </>
  );
}

// handles button and modal overlay
const AddComponent = ({editable_fields, add_new_url}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles()
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => { }, [open]);

  return (
    <td>
      <Button onClick={handleOpen}>Add</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.detailsBox} style={{ 'maxHeight': '100vh', 'overflowY': 'auto' }}>

          <DetailsAddComponent
            editable_fields={editable_fields}
            add_new_url={add_new_url}
          />
        </Box>
      </Modal>
    </td>
  );
};

export default AddComponent;
